import update from 'immutability-helper'

import { toString } from '../../helpers/common'
import { getParameterFromPath } from '../../helpers/url'
import { getLocalStorage } from '../../helpers/storage'
import { deleteItemById, updateItem } from '../../helpers/reducerHelpers'

import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  SELECTED_PARTNERSHIP_ID,
  GET_PARTNERSHIPS,
  GET_PARTNERSHIPS_FAILURE,
  GET_PARTNERSHIPS_SUCCESS,
  CLEAR_PARTNERSHIPS,
  SET_SELECTED_PARTNERSHIP,
  CLEAR_SELECTED_PARTNERSHIP,
  CREATE_PARTNERSHIP,
  CREATE_PARTNERSHIP_SUCCESS,
  CREATE_PARTNERSHIP_FAILURE,
  CLEAR_CREATE_PARTNERSHIP,
  UPDATE_PARTNERSHIP,
  UPDATE_PARTNERSHIP_SUCCESS,
  UPDATE_PARTNERSHIP_FAILURE,
  CLEAR_UPDATE_PARTNERSHIP,
  DELETE_PARTNERSHIP,
  DELETE_PARTNERSHIP_SUCCESS,
  DELETE_PARTNERSHIP_FAILURE,
  CLEAR_DELETE_PARTNERSHIP,
  SEND_OUTSTANDING_ACTIONS_NOTIFICATION,
  SEND_OUTSTANDING_ACTIONS_NOTIFICATION_SUCCESS,
  SEND_OUTSTANDING_ACTIONS_NOTIFICATION_FAILURE,
  CLEAR_OUTSTANDING_ACTIONS_NOTIFICATION
} from '../actions/partnerships'

import { ROUTE_PARAMS } from '../../constants/routes'
import {
  INITIAL_CREATE_REDUCER,
  INITIAL_UPDATE_REDUCER,
  INITIAL_DELETE_REDUCER,
  INITIAL_GET_REDUCER,
  INITIAL_GET_RESULTS_PAGING_REDUCER
} from '../../constants/reducer'

const initialPartnership = getParameterFromPath(ROUTE_PARAMS.partnership) || getLocalStorage(SELECTED_PARTNERSHIP_ID)

export const getDefaultPartnershipId = partnerships => {
  // select first partnership
  return partnerships && partnerships[0] && partnerships[0].id
}
export const initialSelectedPartnership = {}

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  partnerships: INITIAL_GET_RESULTS_PAGING_REDUCER,
  selectedPartnership: initialSelectedPartnership,
  [SELECTED_PARTNERSHIP_ID]: toString(initialPartnership),
  createPartnership: INITIAL_CREATE_REDUCER,
  updatePartnership: INITIAL_UPDATE_REDUCER,
  deletePartnership: INITIAL_DELETE_REDUCER,
  outstandingActionsNotification: INITIAL_GET_REDUCER
}

export default function partnerships(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    // get partnerships
    case GET_PARTNERSHIPS:
      return update(state, {
        partnerships: {
          $merge: {
            isLoading: true,
            results: initialState.partnerships.results
          }
        }
      })
    case GET_PARTNERSHIPS_SUCCESS:
      return update(state, {
        partnerships: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.partnershipsData.results,
            paging: {
              next: action.partnershipsData.next
            }
          }
        }
      })
    case GET_PARTNERSHIPS_FAILURE:
      return update(state, {
        partnerships: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_PARTNERSHIPS:
      return update(state, {
        partnerships: {
          $set: initialState.partnerships
        }
      })

    // set selected partnership
    case SET_SELECTED_PARTNERSHIP:
      return update(state, {
        selectedPartnership: { $set: action.partnershipData },
        [SELECTED_PARTNERSHIP_ID]: { $set: toString(action.partnershipData.id) }
      })
    case CLEAR_SELECTED_PARTNERSHIP:
      return update(state, {
        selectedPartnership: { $set: initialState.selectedPartnership },
        [SELECTED_PARTNERSHIP_ID]: { $set: '' }
      })

    // create partnerships
    case CREATE_PARTNERSHIP:
      return update(state, {
        createPartnership: {
          $merge: { isLoading: true }
        }
      })
    case CREATE_PARTNERSHIP_SUCCESS:
      return update(state, {
        createPartnership: {
          $merge: {
            isLoading: false,
            wasCreated: true
          }
        },
        partnerships: {
          results: {
            $unshift: [action.partnershipData]
          }
        }
      })
    case CREATE_PARTNERSHIP_FAILURE:
      return update(state, {
        createPartnership: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CREATE_PARTNERSHIP:
      return update(state, {
        createPartnership: {
          $set: initialState.createPartnership
        }
      })

    // update partnership
    case UPDATE_PARTNERSHIP:
      return update(state, {
        updatePartnership: {
          $merge: { isLoading: true, id: action.id }
        }
      })
    case UPDATE_PARTNERSHIP_SUCCESS:
      return update(state, {
        updatePartnership: {
          $merge: {
            isLoading: false,
            wasUpdated: true
          }
        },
        partnerships: {
          results: {
            $apply: items => updateItem(items, action.partnershipData)
          }
        }
      })
    case UPDATE_PARTNERSHIP_FAILURE:
      return update(state, {
        updatePartnership: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_PARTNERSHIP:
      return update(state, {
        updatePartnership: {
          $set: initialState.updatePartnership
        }
      })

    // delete partnership
    case DELETE_PARTNERSHIP:
      return update(state, {
        deletePartnership: {
          $merge: {
            isLoading: true,
            id: action.params.id
          }
        }
      })
    case DELETE_PARTNERSHIP_SUCCESS:
      return update(state, {
        deletePartnership: {
          $merge: {
            isLoading: false,
            wasDeleted: true
          }
        },
        partnerships: {
          results: {
            $apply: items => deleteItemById(items, action.id)
          }
        }
      })
    case DELETE_PARTNERSHIP_FAILURE:
      return update(state, {
        deletePartnership: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_DELETE_PARTNERSHIP:
      return update(state, {
        deletePartnership: {
          $set: initialState.deletePartnership
        }
      })

    // notifications
    case SEND_OUTSTANDING_ACTIONS_NOTIFICATION:
      return update(state, {
        outstandingActionsNotification: {
          $merge: {
            isLoading: true
          }
        }
      })
    case SEND_OUTSTANDING_ACTIONS_NOTIFICATION_SUCCESS:
      return update(state, {
        outstandingActionsNotification: {
          $merge: {
            isLoading: false,
            wasLoaded: true
          }
        }
      })
    case SEND_OUTSTANDING_ACTIONS_NOTIFICATION_FAILURE:
      return update(state, {
        outstandingActionsNotification: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_OUTSTANDING_ACTIONS_NOTIFICATION:
      return update(state, {
        outstandingActionsNotification: {
          $set: initialState.outstandingActionsNotification
        }
      })
    default:
      return state
  }
}
